import React from "react";
import { InProgress } from "../../App";
import './Competitions.css'

interface Props { }

export default class Competitions extends React.Component<Props, any> {
    render() {
        return InProgress();
    }
}